import { COMMA_SPACE_DELIMITER } from '@glass/common/modules/strings/constants';
import { ALL_BREAKPOINTS, XS } from '@glass/web/modules/theme/breakpointKeys';
import commonTheme from '@glass/web/modules/theme/common';

const defaultOptions = {
  containerSize: '1280px',
  spacing: 2 * commonTheme.muiTheme.spacing,
};
const defaultBreakpointOptions = {
  [XS]: {
    spacing: commonTheme.muiTheme.spacing,
  },
};

const calcImageSizesV2 = ({ breakpoints = {}, ...options } = {}) => {
  let breakpointSize = breakpoints[XS] || 12;
  return ALL_BREAKPOINTS.map((breakpoint) => {
    const { spacing, containerSize } = {
      ...defaultOptions,
      ...defaultBreakpointOptions[breakpoint],
      ...options,
    };

    breakpointSize = breakpoints[breakpoint] || breakpointSize;
    const numColumns = Math.floor(12 / breakpointSize);
    return `$only(${breakpoint}) calc((min(${containerSize}, 100vw) - (2 * ${spacing}px) - ((${numColumns} - 1) * ${spacing}px)) * ${breakpointSize} / 12)`;
  }).join(COMMA_SPACE_DELIMITER);
};

export default calcImageSizesV2;
